<template>
<div class="headerbox" :style="bgHeadImg">
    <div class="header">
        <div class="bg-red">
		    <div class="head-w f-row-b">
		        <div v-for='(items,ind) in navTop' :key='ind' class="f-row-c">
		            <div v-for="(item,index) in items" :key='index' class="navitem" :class="(ind==0&&index==3)||(ind==1&&index==3)?'':'mr'">
		                <div class="f-row-c" :class="item.path?'':'pinter'" @click="onPage(item,index,true)">
		                    <img class="icon" :src="item.src||''" :alt="item.label||''"/>
		                    <div>{{item.label||''}}</div>
		                </div>
		                <div class="qrcode">
		                    <el-image fit='contain' v-if='item.qrcode'  :src="item.qrcode" :alt="item.label+'二维码'"></el-image>
		                </div>

		            </div>
		        </div>

		    </div>
		</div>
        <div class="bg-img" v-if='true'>
            <div class="head-w f-row-c">
                <div class="">
                    <div class="history">
                        <el-image fit='cover' class="img" :src="require('@/assets/img/index/logo.png')" alt="青海共青团历史征尘"></el-image>
                    </div>
					<div class="banner-txt" >
                        <el-carousel height="53px" direction="vertical" :autoplay="true" indicator-position='none' v-if='isHidden'>
                            <el-carousel-item v-for="(item,ind) in bannerList" :key="item">
                                <el-image fit='contain' class="img-in" :src="item?$fileAccessHttpUrl(item):require('@/assets/img/index/banner-txt.png')" alt="青海共青团警句"></el-image>
                                <!-- <div class="banner-tit" v-if='ind==0'>
                                    青年要坚定理想信念，培育高尚品格，练就过硬本领，勇于创新创造，矢志艰苦奋斗
                                </div>
                                <div class="banner-tit" v-if='ind==1'>
                                    青年一代有理想、有本领、有担当、国家就有前途，民族就有希望。
                                </div> -->
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>

        </div>
		<div v-else style="height: 54px;"></div>
        <div class="nav-h">
            <div class="nav" :class="isFixed?'fixedtop':''">
                <ul class="head-w">
                    <li class="f-row-c" v-for="(item, i) in nav" :key="`nav_${i}`" @click="onPage(item,i)">
                        <div class="headtext">{{item.label||''}}</div>
                        <div class="demo">
                            <div class="f-row-b" v-for="(ite,ind) in item.children" :key='ind' @click.stop="onPage(ite,i)">
                                <span>{{ite.label}}</span><span>》</span>
                            </div>
                        </div>
                        <div :class="i === actindex?'act':''"></div>
                    </li>

                </ul>
            </div>
        </div>

    </div>
</div>

</template>

<script>
export default {
    name: 'Header',
    inject:["isShow"],
    data() {
        return {
            timer:null,
            bgImg:'',//头部自定义底图
            isHidden:true,//是否显示图制文字的banner
            bannerList:[],
            navTop:[
                [
                   {src:require('@/assets/img/index/tuanqi.png'),label:'团旗',
                   title:'/regiment/index?type=1',slotTitle:'1'},
                   {src:require('@/assets/img/index/tuange.png'),label:'团歌',
                   title:'/regiment/index?type=2',slotTitle:'2'},
                   {src:require('@/assets/img/index/tuanhui.png'),label:'团徽',
                   title:'/regiment/index?type=3',slotTitle:'3'},
                   {src:require('@/assets/img/index/tuanzhang.png'),label:'团章',
                    title:'/regiment/list',slotTitle:'4'}
                ],
                [
                   {src:require('@/assets/img/index/weixin.png'),label:'微信',qrcode:require('@/assets/img/index/weixin-code.png'),path:''},
                   {src:require('@/assets/img/index/weibo.png'),label:'微博',qrcode:require('@/assets/img/index/weibo-code.png'),path:''},
                   {src:require('@/assets/img/index/kuaishou.png'),label:'快手',qrcode:require('@/assets/img/index/kuaishou-code.png'),path:''},
                   {src:require('@/assets/img/index/douyin.png'),label:'抖音',qrcode:require('@/assets/img/index/douyin-code.png'),path:''}
                ]
            ],
            isFixed:false,
            actindex:null,
            nav: [
                // {
                //     label: '首页',
                //     title: '/',
                // },
                // {
                //     label: '机构设置',
                //     title: '/Organization',
                // },
                // {
                //     label: '工作动态',
                //     title: '/workNews',
                //     slotTitle:3
                // },
                // {
                //     label: '党建服务',
                //     title: '/partyService',
                //     children:[
                //         {label: '宣传教育',title: '/news?type=14',slotTitle:14},
                //         {label: '专题活动',title: '/news?type=15',slotTitle:15},
                //         {label: '党风廉政',title: '/news?type=16',slotTitle:16},
                //         {label: '党务知识',title: '/news?type=17',slotTitle:17},
                //         {label: '规章制度',title: '/news?type=18',slotTitle:18},
                //         {label: '学习园地',title: '/news?type=19',slotTitle:19},
                //     ]
                // },
                // {
                //     label: '聚焦青年',
                //     title: '/focusYouth',
                //     slotTitle:4
                // },
                // {
                //     label: '维权服务',
                //     title: '/Rights?type=1',
                //     children:[
                //         {label: '热线电话',title: '/Rights?type=1',slotTitle:1},
                //         {label: '在线维权',title: '/Rights?type=2',slotTitle:2},
                //         {label: '维权案例',title: '/Rights?type=3',slotTitle:3},
                //         {label: '法律政策',title: '/Rights?type=4',slotTitle:4},
                //         {label: '法律维权',title: '/Rights?type=5',slotTitle:5},
                //     ]
                // },
                // {
                //     label: '志愿青春',
                //     title: '/youthVolunteer',
                //     children:[
                //         {label: '青年大学习',title: '/news?type=20',slotTitle:20},
                //         {label: '青年发展规划',title: '/news?type=21',slotTitle:21},
                //         {label: '媒体聚焦',title: '/news?type=22',slotTitle:22},
                //         {label: '青年说',title: '/news?type=23',slotTitle:23},
                //     ]
                // },
                // {
                //     label: '文件资料',
                //     title: '/fileInfo',
                //     slotTitle:5
                // },
            ],
        }
    },
    computed:{
        bgHeadImg:function () {
            return `background:url('${this.bgImg}') no-repeat 100%/auto 100%;backgroundSize:cover;`
         },
    },
    watch:{
        nav:function(newVal){
            this.getAct()
        },
        $route:function(newVal){
            this.getAct()
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);　　// 清除定时器
	    this.timer = null;
    },
    created(){
        // this.getNav();
        this.getQrcode()
    },

    mounted(){
        this.$util.goTop();
        // this.getLocalStorage()
        window.addEventListener('scroll', this.onScroll)
    },
    methods: {
        getLocalStorage(){
            if(localStorage.getItem('headActIndex')){
                var val= JSON.parse(localStorage.getItem('headActIndex'))
                var arr=window.location.href.split('#')

                if(arr[1]==val.path){
                        this.actindex=val.index*1;
                }else{
                    var index=localStorage.getItem('titBoxSetIndex')?localStorage.getItem('titBoxSetIndex')*1:0
                    this.actindex=index
                }

            }
        },
        getAct(){
            if(this.nav.length>0){
               var ind = this.nav.findIndex(k=>{
                    return k.title==this.$route.path || (this.$route.path=='/doctorDetail' && k.title=='/doctor')
                })
                if(ind!=-1){
                    this.actindex=ind;
                    var val={path:this.$route.path,index:this.actindex,type:this.$route.query.type}
                    localStorage.setItem('headActIndex',JSON.stringify(val))
                }else{
                    if(this.$route.path=='/phoneBooksList'){
                        this.actindex=0;
                        var val={path:this.$route.path,index:this.actindex,type:this.$route.query.type}
                        localStorage.setItem('headActIndex',JSON.stringify(val))
                        localStorage.setItem('titBoxSetIndex',this.actindex)
                    }
                    if(this.$route.path=='/Rights'){
                        this.actindex=5;
                        var val={path:this.$route.path,index:this.actindex,type:this.$route.query.type}
                        localStorage.setItem('headActIndex',JSON.stringify(val))
                        localStorage.setItem('titBoxSetIndex',this.actindex)
                    }

                    this.getLocalStorage()
                }
            }
        },
        getIndex(url){
            this.onForEach(this.nav,'/'+url)
        },
        fn(list,url,parentInd){
            if(list.list==0){
                return
            }
            list.forEach((k,ind)=>{
                if(k.title==url){ //如果有父级传递的参数则用父级参数
                    this.actindex=parentInd?parentInd:ind;
                }
                if(k.children){
                return this.onForEach(k.children,url,ind)
                }
            })
        },
        onForEach(list,url,parentInd){
           this.fn(list,url,parentInd)
        },
        onrest(){
            this.isShow()
        },
        getQrcode(){
            this.$get('/web/home/queryConfigs').then(res=>{
                if(res.success){
                    this.navTop[1][0].qrcode=res.result.volunteerMini?this.$fileAccessHttpUrl(res.result.volunteerMini):require('@/assets/img/index/weixin-code.png')
                    this.navTop[1][1].qrcode=res.result.schoolMini?this.$fileAccessHttpUrl(res.result.schoolMini):require('@/assets/img/index/weibo-code.png')
                    this.navTop[1][2].qrcode=res.result.provincialMini?this.$fileAccessHttpUrl(res.result.provincialMini):require('@/assets/img/index/kuaishou-code.png')
                    this.navTop[1][3].qrcode=res.result.trillMini?this.$fileAccessHttpUrl(res.result.trillMini):require('@/assets/img/index/douyin-code.png')
                }
            })
        },
        getNav(res){
            console.log('getNav',res)
            if(res){
                if(res.success){
                    this.nav=[]
                    this.nav=res.result.list;
                    this.bannerList=res.result.path.split(',')
                    if(res.result.headImgPath){ //头部自定义底图
                        this.bgImg=this.$fileAccessHttpUrl(res.result.headImgPath)
                    }
                    this.isHidden=res.result.isHidden;//是否显示图制文字的banner
                }
                return
            }
            this.$get('/web/home/queryAllRootList').then(res=>{
                if(res.success){
                    this.nav=[]
                    this.nav=res.result.list;
                    this.bannerList=res.result.path.split(',')
                    // if(res.result.middleSuspend=='true'){//显示头部底图
                        if(res.result.headImgPath){ //头部自定义底图
                            this.bgImg=this.$fileAccessHttpUrl(res.result.headImgPath)
                        }else{
                            this.bgImg=require("@/assets/img/index/head-1.png");
                            // this.bgImg=require('../../assets/img/index/bg.png')
                        }
                    // }else{
                    //     this.bgImg=''
                    // }


                    this.isHidden=res.result.isHidden;//是否显示图制文字的banner
                }
            })
        },
        onPage(item,index,isNavTop){
            if(item.title.indexOf('http')!=-1){
                // window.href=item.title
                window.open(item.title)
            }else{
                this.$util.goTop();
                this.onrest()
                if(!isNavTop){
                    this.actindex=index;
                }
                var  opt={}
                if(item.slotTitle&&item.slotTitle!='null'){
                    opt.type=item.slotTitle
                }
                this.$router.push({
                    path:item.title,
                    query:opt,
                    params:{t:new Date()}
                })
                var val={path:item.title,index:this.actindex,type:opt.type}
                localStorage.setItem('headActIndex',JSON.stringify(val))
            }



        },
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
        },
        onScroll(){
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop <510 ) {//558
               this.isFixed=false
            } else {
               this.isFixed=true
            }
        }

    },

}
</script>

<style lang="scss">
.bottom_img{
	margin-top: 30px;
}
.fixedtop{
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
}
.headerbox{
    width: 100%;
    min-width: 1200px;
    position: relative;
    background-size:cover!important;
    background-position: top center!important;
    background: transparent!important;
}
.header {
    width: 100%;
    min-width: 1200px;
    position: relative;
    background-color: rgba(252, 252, 252, 0);
    .head-w{
        width: 1200px;
        height: 100%;
        padding: 0px;
        margin: 0 auto;
        position: relative;
        padding-inline-start: 0px;
        .banner-tit{
            font-size: 16px;
            line-height: 28px;
            font-weight: bold;
            color: #BA0711;
        }
    }
	.center{
		width: 100% !important;
		height: 102px !important;
		background-color: #991414 !important;
	}
    .bg-red {
       background: transparent;
       height: 54px;
       color: #BA0711;
       font-size: 16px;
       position: absolute;
       z-index: 1;
       width: 100%;
       .navitem{
           position: relative;
           height:20px ;
           line-height: 20px;
           .icon{
                max-height: 18px;
                max-width: 27px;
                margin-right: 10px;
            }
            .qrcode{
                width: 100px;
                height: 100px;
                left: calc(50% - 50px);
                position: absolute;
                top: 34px;
                display: none;
                img,.el-image{
                    width: 100%;
                    // height: 100%;
                }
            }
       }
       .navitem:hover{
           .qrcode{
               display: block;
			   z-index: 10;
           }
       }
       .mr{
           margin-right: 30px;
       }

    }
	.center,
    .bg-img{
        width: 100%;
        min-width: 1200px;
        height: 425px;
        .history{
            position: relative;
            width:648px;
            height: 164px;
            .img{
                width: 100%;
                height: 164px;
            }

        }
        .banner-txt{
            position: absolute;
            width:648px;
            // height: 53px;
            right: 100px;
            top: calc(50% + 53px);
            .img-in{
                width: 100%;
                height: 53px;
            }
        }
        .logo {
            display: block;
            width: 417px;
            height: 119px;
            position: absolute;
            cursor: pointer;
            overflow: hidden;
            position: absolute;
            left: 0px;
            bottom: -12px;
            .img{
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

}
.nav-h{
    height: 54px;
}
.nav-h,
.nav {
    background-color: rgba(252, 252, 252, 0);

    ul {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #AA0F14;
        li {
            position: relative;
            padding-right: 10px;
            min-width: 110px;
            height: 54px;
            line-height: 54px;
            text-align: center;
            list-style: none;
            color: #fff;
            font-size: 18px;
            cursor: pointer;
            flex-grow: 1;
            .headtext{
                position: relative;
                z-index: 11;
                white-space: nowrap;
            }
            .demo{
                display: none;
                position: absolute;
                z-index: 12;
                background-color: #AA0F14;
                min-width: 150px;
                left: calc(50% - 75px);
                font-size: 16px;
                top: 54px;
                div{
                    height: 44px;
                    line-height: 44px;
                    padding-left: 20px;
                }
                div:hover{
                    background: #AA0F14;
                    background: rgba($color: #ffffff, $alpha: 0.17);
                }
            }
            .act{//#BA0711
                background:  url(../../assets/img/headbg.png) no-repeat;
                background-size:100% 100%;
                background-position: center right!important;
                position: absolute;
                width: 100%;
                height: 60px;
                z-index: 10;
                left: 0px;
                top: -6px;
                // left: calc(50%);
                // transform: translate(-50%,calc(-6px - 50%));
                // top: calc(50%);
            }
        }

        li:hover{
            // background: rgba($color: #ffffff, $alpha: 0.17);
            // border-radius: 5px;
            .demo{display: block;}
        }
    }

}
</style>
